/* Love N Care — photo A/B test tracking (snippets/lnc-ab.liquid sets window.LNC_AB.v before paint).
   One version per visitor across all tests; LNC_AB.tests maps each test collection to its test id
   (cots-furniture → img-cots, bedside-sleepers → img-sleep). Counted ONCE PER VISIT (sessionStorage), per test,
   and only for visits that opened that test's collection page:
     view  = saw the collection        click = opened a product card from it
     atc   = added something to the bag later in that visit
   The cart also gets a hidden attribute per test (_lnc_ab_img for img-cots, _lnc_ab_img_sleep for img-sleep) =
   life|white, so orders show the version (scripts/lnc-ab-photo-test.py).
   ?lnc_ab=life|white forces a version for QA and keeps that browser session out of the counts (qa: true). */
(function () {
  var A = window.LNC_AB;
  if (!A || !A.active || !A.tests) return;
  var TRACK = 'https://lnc-alerts.square-voice-ee10.workers.dev/ab';
  var m = location.pathname.match(/^\/collections\/([^\/]+)/);
  var here = m && A.tests[m[1]]; // test id of the collection on screen, if it is a test page
  var ids = [];
  for (var c in A.tests) if (Object.prototype.hasOwnProperty.call(A.tests, c)) ids.push(A.tests[c]);
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  // img-cots keeps its original keys (lnc-ab-view …) so visits already under way when img-sleep launched count once
  function key(t, ev) { return 'lnc-ab-' + (t === 'img-cots' ? '' : t + '-') + ev; }
  function attr(t) { return t === 'img-cots' ? '_lnc_ab_img' : '_lnc_ab_' + t.replace(/-/g, '_'); }
  function send(t, ev) {
    if (ss(key(t, ev))) return;               // once per visit
    ss(key(t, ev), '1');
    try {
      fetch(TRACK, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'content-type': 'text/plain' },
        body: JSON.stringify({ t: t, v: A.v, e: ev, qa: !!A.qa }) });
    } catch (e) {}
  }
  if (here) {
    send(here, 'view');
    if (!ss(key(here, 'tagged'))) {
      ss(key(here, 'tagged'), '1');
      var attrs = {};
      attrs[attr(here)] = A.v + (A.qa ? '-qa' : '');
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('#product-grid a[href*="/products/"]');
      if (a) send(here, 'click');
    }, true);
  }
  // Add to bag later in the same visit (card quick-add, product page, bag upsells) — any successful /cart/add,
  // counted for every test whose collection this visit has seen.
  function seen() { return ids.filter(function (t) { return ss(key(t, 'view')); }); }
  if (seen().length && window.fetch && !window.__lncAbFetch) {
    window.__lncAbFetch = true;
    var f = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = f.apply(this, arguments);
      if (/\/cart\/add/.test(url) && (!init || (init.method || 'GET').toUpperCase() === 'POST')) {
        p.then(function (r) { if (r && r.ok) seen().forEach(function (t) { send(t, 'atc'); }); }).catch(function () {});
      }
      return p;
    };
  }
})();
